import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { usePlatformAPI } from "@/api/PlatformProvider";
import { PartnerForm } from "./PartnerForm";

function CreatePartnerPage() {
    const api = usePlatformAPI();
    const navigate = useNavigate();

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-row items-center gap-4">
                <button onClick={() => navigate("/partners")} className="text-grey hover:text-dark-dark-grey flex items-center gap-1">
                    <ArrowBackIcon fontSize="small" />
                </button>
                <h1 className="text-xl font-semibold">Create Partner</h1>
            </div>
            <PartnerForm
                submitLabel="Create Partner"
                onSubmit={async (name, description) => {
                    const [, err] = await api.post("api/partners", { name, description });
                    if (err) throw err;
                    navigate("/partners");
                }}
            />
        </div>
    );
}

export default CreatePartnerPage;
